import { Directive, ElementRef, inject, Optional, Renderer2 } from '@angular/core';
import { EretailMenuWrapperComponent } from '../eretail-menu-wrapper/eretail-menu-wrapper.component';

@Directive({
  selector: '[item-close-menu]',
  standalone: true
})
export class ItemCloseMenuDirective {

  private _elementRef = inject(ElementRef);
  private _renderer = inject(Renderer2);

  @Optional()
  private _parent: EretailMenuWrapperComponent = inject(EretailMenuWrapperComponent);

  constructor() {
    if (!this._parent) {
      throw new Error('item-close-menu can only be used within components that implements/extends EretailMenuLogicWrapperComponent!');
    }

    this._renderer.listen(this._elementRef.nativeElement, 'click', () => {
      this.closeMenu();
    });
  }

  protected closeMenu() {
    this._parent?.closeMenu();
  }
}
